module.exports = __webpack_public_path__ + "img/vertical_2_1_7016.af86760e.png";